import { ArrowBackIos as ArrowBack } from '@material-ui/icons';
import { Button, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  actionButton: {
    background: 'none',
    color: theme.iconColor,
    boxShadow: 'none',
    fontSize: theme.headerTextFontSize,
    marginRight: 24,
    fontWeight: 600,
    padding: '0',
    minWidth: 'auto',
    '&:hover': {
      background: theme.btnHoverColor
    }
  },
  icon: {
    marginRight: 4
  }
});

const BackButton = ({ onClick, classes }) => (
  <Button classes={{ root: classes.actionButton }} variant="text" color="primary" onClick={onClick}>
    <ArrowBack className={classes.icon} /> Back
  </Button>
);

export default withStyles(styles)(BackButton);
